module.exports = __webpack_public_path__ + "img/group-bg.7770954e.jpg";